import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c30a5c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register-detail" }
const _hoisted_2 = { class: "item text-overflow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司首编码：", -1))
const _hoisted_4 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司全称：", -1))
const _hoisted_6 = { class: "item text-overflow" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司简称：", -1))
const _hoisted_8 = { class: "register-detail" }
const _hoisted_9 = { class: "item text-overflow" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司简称首拼：", -1))
const _hoisted_11 = {
  class: "item text-overflow",
  style: {"width":"500px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司简称全拼：", -1))
const _hoisted_13 = { class: "register-detail" }
const _hoisted_14 = { class: "item text-overflow" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司VP姓名：", -1))
const _hoisted_16 = { class: "long-item text-overflow" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "法人：", -1))
const _hoisted_18 = { class: "register-detail" }
const _hoisted_19 = { class: "item text-overflow" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "工位数量：", -1))
const _hoisted_21 = { class: "long-item text-overflow" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "所在城市：", -1))
const _hoisted_23 = { class: "register-detail" }
const _hoisted_24 = { class: "long-item text-overflow" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "所属大区：", -1))

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import { companyAccountDetail } from "@/api/process_company";


export default /*#__PURE__*/_defineComponent({
  props: {
    detail: null
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { detail: {
      CompanyName: string;
      FullName: string;
      Quanpin: string;
      Shoupin: string;
      ManagerStaffId: number;
      ManagerStaffName: string;
      PrefixCode: string;
      StationNumber: number;
      LegalStaffId: number;
      LegalStaffName: string;
      LocationCode: string;
      LocationName: string;
      RegionName: string;
    } }





return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(props.detail.PrefixCode), 1)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(props.detail.FullName), 1)
      ]),
      _createElementVNode("span", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(props.detail.CompanyName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(props.detail.Shoupin), 1)
      ]),
      _createElementVNode("span", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_a_tooltip, null, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.detail.Quanpin), 1)
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(props.detail.Quanpin), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("span", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("span", null, _toDisplayString(props.detail.ManagerStaffName), 1)
      ]),
      _createElementVNode("span", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("span", null, _toDisplayString(props.detail.LegalStaffName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("span", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("span", null, _toDisplayString(props.detail.StationNumber), 1)
      ]),
      _createElementVNode("span", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("span", null, _toDisplayString(props.detail.LocationName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("span", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("span", null, _toDisplayString(props.detail.RegionName), 1)
      ])
    ])
  ], 64))
}
}

})